import React, { FC, useEffect, useRef } from 'react';
import { Box, Button, makeStyles, Theme, SwipeableDrawer, Typography, Divider } from '@material-ui/core';
import { ArrowLeftGreyIcon } from 'svgs';

export interface DrawerModalProps {
  open: boolean;
  onClose: () => void;
  onScrollEnd?: () => Promise<void>;
}

const useStyles = makeStyles((theme: Theme) => ({
  backWrapper: {
    padding: theme.spacing(1, 0),
    '& button': {
      color: 'transparent',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '&:hover': {
      '& span': {
        '& svg': {
          '& path': {
            fill: theme.palette.primary.main,
          },
        },
        '& h6': {
          color: theme.palette.primary.main,
        },
      },
    },
  },
  title: {
    color: theme.palette.secondary.dark,
    fontWeight: 500,
    paddingLeft: theme.spacing(4),
  },
  paperWrapper: {
    width: '100%',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(5, 5),
    },
    [theme.breakpoints.up('md')]: {
      width: 600,
    },
    [theme.breakpoints.up('lg')]: {
      width: 1100,
    },
  },
  divider: {
    width: '100%',
    height: 1,
    backgroundColor: theme.palette.secondary.light,
    margin: theme.spacing(2, 0),
    maxWidth: 900,
  },
}));

const DrawerModal: FC<DrawerModalProps> = (props) => {
  const { children, open, onClose, onScrollEnd } = props;
  const classes = useStyles();
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || !onScrollEnd) {
      return;
    }
    const el = ref.current.querySelector('.MuiPaper-root');
    let done = true;
    el.onscroll = async () => {
      const { scrollTop, scrollHeight, clientHeight } = el;
      if (scrollTop + clientHeight >= scrollHeight - 5 && done) {
        done = false;
        await onScrollEnd();
        done = true;
      }
    };
  }, [ref.current]);

  return (
    <SwipeableDrawer
      onOpen={console.log}
      ref={ref}
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{ paperAnchorRight: classes.paperWrapper }}
    >
      <div role="presentation">
        <Box className={classes.backWrapper}>
          <Button onClick={onClose} tabIndex="-1">
            <Box ml={-0.4} />
            <ArrowLeftGreyIcon />
            <Typography variant="h6" className={classes.title}>
              BACK
            </Typography>
          </Button>
        </Box>
        <Divider className={classes.divider} />
        {children}
      </div>
    </SwipeableDrawer>
  );
};

export default DrawerModal;
